import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { accompanyingVisitDelete, accompanyingVisitList } from '@/api/yuntuSales/superivisorAccompanyingVisit'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { AccompanyingVisitItem, AccompanyingVisitListParams } from '@/typings/api/yuntuSales'
import { cloneDeep } from 'lodash-es'


const __default__ = { name: 'DcCosLbuSupervisorAccompanyingVisit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loading = ref(false)

const router = useRouter()
const route = useRoute()
const tableRef = ref()

const selectedRows = ref<AccompanyingVisitItem[]>([])
const queryForm = ref<AccompanyingVisitItem>({})
// 获取列表
const fetch = async (queryForm: AccompanyingVisitListParams, callBack: (res: any) => void) => {
  accompanyingVisitList(queryForm).then((res) => {
    callBack(res)
  })
}
const onSelectChange = (selectedRowKeys: string[], rows: AccompanyingVisitItem[]) => {
  selectedRows.value = rows
}
// 编辑
const handleEdit = (record: AccompanyingVisitItem) => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/edit',
    query: {
      id: record.id
    }
  })
}
// 删除
const handleDelete = (record: AccompanyingVisitItem) => {
  Modal.delete({
    name: record.id,
    onOk() {
      loading.value = true
      accompanyingVisitDelete({
        id: record.id
      })
        .then((res) => {
          tableRef.value.delFetch()
          message.success('删除成功')
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
// 新增
const handleAdd = () => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/add'
  })
}
// 评论
const commentRow = (row: AccompanyingVisitItem) => {
  router.push({
    path: '/lbu/supervisorAccompanyingVisit/comment',
    query: {
      id: row.id
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 36
const columns = computed(() => [
  {
    title: 'ID',
    dataIndex: 'id',
    cosType: 'link',
    path: '/lbu/supervisorAccompanyingVisit/view',
    query: ['id']
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '跟进记录',
    dataIndex: 'startTime'
  },
  {
    title: '客户负责人',
    dataIndex: 'sellerName'
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '陪访过程',
    dataIndex: 'process'
  },
  {
    title: '后续跟进',
    dataIndex: 'followUp'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            columns: columns.value,
            tableId: "lbusupervisorAccompanyingVisit",
            onFetch: fetch,
            search: queryForm.value,
            "onUpdate:search": _cache[7] || (_cache[7] = ($event: any) => ((queryForm).value = $event)),
            ref_key: "tableRef",
            ref: tableRef
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.customerName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: queryForm.value.seller,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.seller) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: queryForm.value.createBy,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.createBy) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "startTime",
                    label: "创建时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: queryForm.value.startTime,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.value.startTime) = $event)),
                        endTime: queryForm.value.endTime,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "id",
                    label: "ID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.value.id,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.value.id) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleEdit(record)),
                      workCode: record.createBy
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "workCode"])), [
                      [_directive_permission, 'lbu_accompanying_visit_edit_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleDelete(record)),
                      workCode: record.createBy,
                      onSuccess: success
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick", "workCode"])), [
                      [_directive_permission, 'lbu_accompanying_visit_del_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (commentRow(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("评论 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'lbu_accompanying_visit_comment_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (handleAdd(_ctx.record))),
                onSuccess: success
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_accompanying_visit_add']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "309",
                search: queryForm.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出 ")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_accompanying_visit_export']
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})